export default __webpack_public_path__ + "static/media/chain-22.639d0ef6.png";